import { useEffect, useState } from "react"
import { EnumSignture, KeydrivePlan } from "../model/UserModel"
import { useProfile } from "../context/ProfileProvider/useProfile";
import { useParams } from "react-router-dom";

export default function useExtractPlan() {
    const [keydrivePlan, setKeydrivePlan] = useState<KeydrivePlan | undefined>(undefined);
    const [planName, setPlanName] = useState<string>("");
    const [signtureStatus, setSigntureStatus] = useState<EnumSignture>(EnumSignture.Free);
    const { signtureInformation } = useProfile();
    const { nameOrg } = useParams();

    useEffect(() => {
        if (signtureInformation == undefined || signtureInformation == null) return;

        if (signtureInformation?.signture == undefined || signtureInformation?.signture == null) return;

        switch(signtureInformation.signture) {
            case EnumSignture.Free:
                setSigntureStatus(EnumSignture.Free);
                break;
            case EnumSignture.Canceled:
                setSigntureStatus(EnumSignture.Canceled);
                break;
            case EnumSignture.Premium:
                setSigntureStatus(EnumSignture.Premium);
                break;
            case EnumSignture.Hold:
                setSigntureStatus(EnumSignture.Hold);
                break;
        }

    }, [nameOrg]);

    useEffect(() => {
        if (signtureInformation == undefined || signtureInformation == null) return;

        if (signtureInformation?.currentPlan == undefined || signtureInformation?.currentPlan == null) return;

        setKeydrivePlan(signtureInformation?.currentPlan);
    }, [nameOrg]);

    useEffect(() => {
        switch(keydrivePlan) {
            case KeydrivePlan.PERSONAL:
                setPlanName("Personal");
                break;
            case KeydrivePlan.FREE:
                setPlanName("Gratuito");
                break;
            case KeydrivePlan.PROFISSIONAL:
                setPlanName("Profissional");
                break;
            case KeydrivePlan.SCALE:
                setPlanName("Scale");
                break;
            case KeydrivePlan.ESSENCIAL:
                setPlanName("Essencial");
                break;   
        }
    }, [nameOrg])

    return {
        keydrivePlan, 
        planName,
        signtureStatus
    }
}